<template>
	<div class="xg-pic-box" v-show="isShowed">
		<img src="/images/other.png" class="rounded xg-rect" :class="{'xg-main-pic': isShowed}" />
	</div>
</template>

<script>
	export default {
		props: {
			isShowed: {
				type: Boolean,
				required: false,
				default: true
			}
		}
	}
</script>

<style>
</style>